const API_URL = process.env.API_URL

export default {
	uriLogin() {
		return `${API_URL}/auth/login`
	},

	uriNotifToken() {
		return `${API_URL}/auth/notif-token`
	},

	uriResolveTenant() {
		return `${API_URL}/v2/auth/resolve-tenant`
	},

	uriResolveTenantGoogle() {
		return `${API_URL}/v2/auth/resolve-tenant-google`
	},

	uriSubscribeTopic() {
		return `${API_URL}/staff/subscribe-topic`
	},

	uriAnalytics() {
		return `${API_URL}/statistics/dashboard`
	},

	uriDashboard(id = "") {
		return `${API_URL}/statistics/business/${id}`
	},

	uriLogs() {
		return `${API_URL}/statistics/logs`
	},

	uriLogout() {
		return `${API_URL}/auth/logout`
	},

	uriStaff(id = "") {
		return `${API_URL}/staff/${id}`
	},

	uriRecoverPassword(id = "") {
		return `${API_URL}/staff/recover-password/${id}`
	},

	uriStaffPassword() {
		return `${API_URL}/staff/password`
	},

	uriStaffEmail() {
		return `${API_URL}/staff/email`
	},

	uriPages(id = "") {
		return `${API_URL}/pages/${id}`
	},

	uriEmailTemplate(id = "") {
		return `${API_URL}/email-templates/${id}`
	},

	uriCountries(id = "") {
		return `${API_URL}/countries/${id}`
	},

	uriBusinesses(id = "") {
		return `${API_URL}/businesses/${id}`
	},

	uriContracts(id = "") {
		return `${API_URL}/contracts/${id}`
	},

	uriBusinessContract(businessId = "", contractId = "") {
		return `${API_URL}/businesses/${businessId}/contracts/${contractId}`
	},

	uriOrders(id = "") {
		return `${API_URL}/orders/${id}`
	},
	uriOrderClassification(id = "") {
		return `${API_URL}/orders/${id}/classification`
	},
	uriBulkClassification(action: "validate" | "undo" | "reclassify") {
		return `${API_URL}/orders/bulk-classification/${action}`
	},
	uriImportFile() {
		return `${API_URL}/orders/import-file`
	},
	uriUserFromClientId(id = "") {
		return `${API_URL}/orders/user/${id}`
	},
	uriCreateNewOrder() {
		return `${API_URL}/orders/create-new-order`
	},
	uriOrdersToAggregate() {
		return `${API_URL}/orders/toAggregation`
	},
	uriVehicles(id = "") {
		return `${API_URL}/vehicles/${id}`
	},
	uriRoutes(id = "") {
		return `${API_URL}/routes/${id}`
	},
	uriRoute4meSync() {
		return `${API_URL}/routes/route4meSync`
	},
	uriAggregation() {
		return `${API_URL}/orders/aggregation`
	},
	uriGrids(id = "") {
		return `${API_URL}/grids/${id}`
	},
	uriShifts(id = "") {
		return `${API_URL}/shifts/${id}`
	},
	uriContractTypes(id = "") {
		return `${API_URL}/contract-types/${id}`
	},
	uriLabelTemplates(id = "") {
		return `${API_URL}/label-templates/${id}`
	},
	uriNotificationTemplates(id = "") {
		return `${API_URL}/notification-templates/${id}`
	},
	uriNotificationTemplateTest(id = "") {
		return `${API_URL}/notification-templates/${id}/test`
	},
	uriMasterData(id = "") {
		return `${API_URL}/master-data/${id}`
	},
	uriGeojsonZones(id = "") {
		return `${API_URL}/geojson-zones/${id}`
	},
	uriUsers(id = "") {
		return `${API_URL}/users/${id}`
	},
	uriOrdersDevDelete() {
		return `${API_URL}/orders/devDelete`
	},
	uriSettings(id = "") {
		return `${API_URL}/settings/${id}`
	},
	uriMessagingNotify() {
		return `${API_URL}/messaging/notify`
	},

	// V2 Endpoints
	v2: {
		uriBusinesses({
			businessId = "",
			includeContracts = false,
		}: { businessId?: string; includeContracts?: boolean } = {}) {
			const params = new URLSearchParams()
			if (includeContracts) {
				params.append("includeContracts", "true")
			}
			const queryString = params.toString()
			return `${API_URL}/v2/businesses/${businessId}${queryString ? `?${queryString}` : ""}`
		},
		uriOrders(id = "") {
			return `${API_URL}/v2/orders/${id}`
		},
		uriOrderExternalStatusOverride(id = "") {
			return `${API_URL}/v2/orders/${id}/external-status-override`
		},
		uriOrderExternalDeliveryEligibility() {
			return `${API_URL}/v2/orders/external-delivery/eligibility`
		},
		uriRoutes({
			routeId = "",
			businessId = "",
			contractId = "",
			status,
			date,
			routeType,
			page,
			pageSize,
			search,
		}: {
			routeId?: string
			businessId?: string
			contractId?: string
			status?: string[]
			date?: string
			routeType?: string
			page?: number
			pageSize?: number
			search?: string
		} = {}) {
			const params = new URLSearchParams()
			Object.entries({
				businessId,
				contractId,
				status,
				date,
				routeType,
				page,
				pageSize,
				search,
			}).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== "") {
					if (Array.isArray(value)) {
						value.forEach((v) => params.append(key, v))
					} else {
						params.append(key, String(value))
					}
				}
			})
			const queryString = params.toString()

			return `${API_URL}/v2/routes/${routeId ? routeId : `?${queryString}`}`
		},
		uriVehicles(id = "") {
			return `${API_URL}/v2/vehicles/${id}`
		},
		uriStaff(id = "") {
			return `${API_URL}/v2/staff/${id}`
		},
		uriSettings(id = "") {
			return `${API_URL}/v2/settings/${id}`
		},
		uriTenants(id = "") {
			return `${API_URL}/v2/tenants/${id}`
		},
		uriSectorsMap(action = "") {
			return `${API_URL}/v2/sectors-map/${action}`
		},
		uriMoveOrders() {
			return `${API_URL}/v2/routes/move-orders`
		},
		uriPreviewRouteOptimization() {
			return `${API_URL}/v2/routes/optimize/preview`
		},
		uriApplyRouteOptimization() {
			return `${API_URL}/v2/routes/optimize/apply`
		},
	},
}
